import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const dominios = {
	state: {
		dominios: {
			localidades: ''
		},
		aniosAcademicos:null
	},
	getters: {
		getDominios: state => state.dominios,
		getLocalidades: state => {

			return (idProvincia) => {

				let localidades;

				if (!!state.dominios.localidades) {
					localidades = state.dominios.localidades.filter(l => l.idProvincia == idProvincia);
					localidades = localidades.sort(function (p1, p2) {
						return (p1.descripcion < p2.descripcion) ? -1 : 1;
					});
				}



				return localidades

			}
		},
		getLocalidad: state => {
			return (idLocalidad) => {

				let localidad;

				if (!!state.dominios.localidades) {
					localidad = state.dominios.localidades.filter(l => l.idLocalidad == idLocalidad)[0];
				}
				return localidad

			}
		},
		getAniosAcademicos: state => state.aniosAcademicos,
		getDominiosOrder: state => {
			let dominios = new Object();

			if (!!state.dominios) {
				Object.entries(state.dominios).forEach(d => {
					if (!!d[1]) {
						dominios[d[0]] = Object.entries(d[1]).sort(function (p1, p2) {
							return (p1[1] < p2[1]) ? -1 : 1;
						});
					}
				});
			}

			return dominios;

		},
	},
	actions: {
		requestDominios: ({ commit, getters, dispatch }) => {
			dispatch('requestMotivosRechazo');
			dispatch('requestAniosAcademicos');
		},
		requestAniosAcademicos: ({ commit, getters }) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/aniosAcademicos`).then(response => {
					if (response.data.status == 0 && response.data.datos) {
						commit('setAniosAcademicos', response.data.datos)
					}
				}).catch(function (error) {
					reject(false);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestMotivosRechazo: ({ commit, getters }) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/motivoRechazoPracticas/${getters.getLanguage}`).then(response => {
					if (!!response.data.datos) {
						commit('setMotivosRechazo', response.data.datos)
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestPaises: ({ commit, getters }) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/paises/${getters.getLanguage}`).then(response => {
					if (!!response.data.datos) {
						commit('setPaises', response.data.datos)
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestProvincias: ({ commit, getters }) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/provincias/${getters.getLanguage}`).then(response => {
					if (!!response.data.datos) {
						commit('setprovincias', response.data.datos)
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestLocalidades: ({ commit, getters }) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/localidades/${getters.getLanguage}`).then(response => {
					if (!!response.data.datos) {
						commit('setLocalidades', response.data.datos)
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		}
	},
	mutations: {
		setMotivosRechazo(state, data) {
			state.dominios['motivoRechazoPracticas'] = data
		},
		setprovincias(state, data) {
			state.dominios['provincias'] = data
		},
		setLocalidades(state, data) {
			state.dominios['localidades'] = data
		},
		setPaises(state, data) {
			state.dominios['paises'] = data
		},
		setAniosAcademicos(state, data) {
			state.aniosAcademicos = data
		},

	}
}

export default dominios;



// WEBPACK FOOTER //
// ./src/store/dominios.js